<template>
  <div class="container">
    <!--搜索-->
    <div class="list-wrapper">
      <div class="table-wrap">
        <!-- 顶部筛选栏 -->
        <div class="filter-header">
          <div class="filter-left">
            <span class="filter-label">通知时间:</span>
            <el-date-picker
              v-model="searchForm.date"
              type="daterange"
              size="mini"
              value-format="yyyy-MM-dd"
              range-separator=" - "
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              unlink-panels
              class="date-picker"
              style="width: 228px"
            ></el-date-picker>
            <div class="filter-buttons">
              <el-button
                v-for="filter in filterButtons"
                :key="filter.key"
                :class="['filter-btn', { active: isFilterActive(filter.key) }]"
                size="mini"
                @click="toggleFilter(filter.key)"
              >
                {{ filter.label }}
              </el-button>
            </div>
          </div>
          <div class="search-btn-box">
            <el-button type="primary" size="mini" class="search-btn" @click="init">搜索</el-button>
            <el-button type="info" size="mini" class="buttonStyle" style="margin-left: 5px" @click="reset">重置</el-button>
          </div>
        </div>

        <!-- 主体内容区域 -->
        <div class="main-grid">
          <!-- 第一行 -->
          <div class="top-section">
            <!-- 统一的头部 -->
            <div class="unified-header">
              <div class="header-left">
                <span class="title">在售品变更数据</span>
                <span class="title-sub">({{ dateStartText }}-{{ dateEndText }})</span>
              </div>
              <div class="header-right">
                <span class="link-text" @click="goFastProductArrivalData">查看明细数据</span>
              </div>
            </div>
            <div class="title-img">
              <el-image :src="titleImg"></el-image>
            </div>
            
            <div class="top-row row">
              <!-- 左侧：在售品变更数据 -->
              <div class="col top-left block">
                <div class="change-summary">
                  <div class="change-data-box">
                    <div class="change-main">
                      <div class="change-label">变更商品数合计</div>
                      <div class="change-value">{{ mock.changeSummary.total }}</div>
                      <div class="change-yoy">同比{{ mock.changeSummary.yoy }}</div>
                    </div>
                    <div class="change-hexagon">
                      <el-image :src="bitmapImg" class="hexagon-image"></el-image>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 右侧：在售品变更数据趋势 -->
              <div class="col top-right block">
                <div ref="changeTrend" class="chart-container"></div>
              </div>
            </div>
          </div>

          <!-- 第二行 -->
          <div class="bottom-row row">
            <!-- 左侧：店铺上架数据 -->
            <div class="col bottom-left block">
              <div class="block-header">
                <div class="header-left">
                  <span class="title">店铺处理数据</span>
                  <span class="title-sub">({{ dateStartText }}-{{ dateEndText }})</span>
                </div>
              </div>
              <div>
                <el-image :src="titleImg"></el-image>
              </div>
              <div class="status-summary">
                <div class="status-kpi">
                  <div class="status-label">需上架总商品数 (个)</div>
                  <div class="status-value">{{ mock.meta.needMount }}</div>
                </div>
                <div class="status-kpi">
                  <div class="status-label">平均完成上架周期 (天)</div>
                  <div class="status-value">{{ mock.meta.avgDays }}</div>
                </div>
              </div>
              <div class="rings-grid">
                <div v-for="item in mock.rings" :key="item.ref" class="ring-box">
                  <div :ref="item.ref" class="ring-chart"></div>
                </div>
              </div>
            </div>

            <!-- 右侧：店铺上架数据趋势表现 -->
            <div class="col bottom-right block">
              <div class="block-header">
                <div class="header-left">
                  <span class="title">店铺处理数据趋势表现</span>
                  <span class="title-sub">({{ dateStartText }}-{{ dateEndText }})</span>
                </div>
                <div class="header-right">
                  <span class="link-text" @click="goFastProductArrivalData">查看明细数据</span>
                </div>
              </div>
              <div>
                <el-image :src="titleImg"></el-image>
              </div>
              <div ref="storesBarLine" class="chart-container"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleImg from '@/assets/images/newProduct_img/headerTitle.png';
import upImg from '@/assets/images/newProduct_img/up.png';
import downImg from '@/assets/images/newProduct_img/down.png';
import bitmapImg from '@/assets/images/newProduct_img/bitmap.png';
import statusRings from './statusRings.mixin';
import storesBarLine from './storesBarLine.mixin';
import changeTrend from './changeTrend.mixin';
import moment from 'moment';
export default {
  name: 'salesChangeStatistics',
  mixins: [statusRings, storesBarLine, changeTrend],
  data() {
    return {
      searchForm: {
        date: [moment().subtract('month', 6).format('YYYY-MM-DD'), moment().subtract('days').format('YYYY-MM-DD')],
        type: ['', '价格相关', '设计图', '销售状态', '发货周期', 'SKU推广名称','通栏图','是否松木']
      },
      activeFilter: '',
      filterButtons: [
        { key: '', label: '全部' },
        { key: '价格相关', label: '价格相关' },
        { key: '设计图', label: '设计图' },
        { key: '销售状态', label: '销售状态' },
        { key: '发货周期', label: '发货周期' },
        { key: 'SKU推广名称', label: 'SKU推广名称' },
        { key: '通栏图', label: '通栏图' },
        { key: '是否松木', label: '是否松木' },
      ],
      titleImg: titleImg,
      upImg: upImg,
      downImg: downImg,
      bitmapImg: bitmapImg,
      dateStartText: '',
      dateEndText: '',
      distributorList: [],
      searchFormData: {},
      loading: false,
      loading1: false,
      loading2: false,
      colorIndex: 0,
      buttomList: [],
      platforList: [],
      storeList: [],
      currencyForm: {
        pageSize: 10000,
        pageNum: 1,
        reportCode: '',
        param: '',
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: '',
        groupAttr: '',
      },
      storesPoorList: [],
      interfaceNum: 0,
      overviewText: [],
      loadingNumber: 0,
      timeText: {},
      mock: {
        topSummary: { total: 150, yoy: '+30%' },
        rings: [
          { ref: 'ring1', name: '已处理', value: 0, percent: '0%' },
          { ref: 'ring2', name: '未上架', value: 0, percent: '0%' },
          { ref: 'ring3', name: '待处理', value: 0, percent: '0%' },
          { ref: 'ring4', name: '暂缓处理', value: 0, percent: '0%' },
        ],
        meta: { needMount: 0, avgDays: 0 },
        changeSummary: { total: 0, yoy: '0%' },
        changeTrend: {
          months: [],
          priceChange: [],
          design: [],
          delivery: [],
          salesStatus: [],
          skuPromotion: [],
          fullWidthQty: [],
          pineQty: [],
        },
        stores: [],
      },
    };
  },
  computed: {
    dateStart() {
      return JSON.parse(JSON.stringify(this.searchForm.date[0]));
    },
    dateEnd() {
      return JSON.parse(JSON.stringify(this.searchForm.date[1]));
    },
    windowWidth() {
      return window.innerWidth;
    },
  },
  watch: {
    dateStart: {
      handler(val, old) {
        if (!val) return;
        let dateStart = val.substring(4).replace(/-/g, '');
        let startMonth = parseInt(dateStart.substring(0, 2));
        let startDay = parseInt(dateStart.substring(2));
        this.dateStartText = startMonth + '.' + startDay;
      },
      immediate: true,
    },
    dateEnd: {
      handler(val, old) {
        if (!val) return;
        let dateEnd = val.substring(4).replace(/-/g, '');
        let endMonth = parseInt(dateEnd.substring(0, 2));
        let endDay = parseInt(dateEnd.substring(2));
        this.dateEndText = endMonth + '.' + endDay;
      },
      immediate: true,
    },
    loadingNumber(val, old) {
      if (val == 4) {
        this.loading.close();
        this.loadingNumber = 0;
      }
    },
  },
  methods: {
    reset() {
      this.searchForm = {
        date: [moment().subtract('month', 6).format('YYYY-MM-DD'), moment().subtract('days').format('YYYY-MM-DD')],
        type: ['', '价格相关', '设计图', '销售状态', '发货周期', 'SKU推广名称','通栏图','是否松木']
      };
      this.init();
    },
    // 切换筛选项
    toggleFilter(key) {
      // 获取所有非"全部"按钮的keys
      const allOtherKeys = this.filterButtons.filter(f => f.key !== '').map(f => f.key);
      
      // 如果点击的是"全部"
      if (key === '') {
        // 选中"全部"时,选中所有选项
        this.searchForm.type = ['', ...allOtherKeys];
      } else {
        // 点击其他选项
        const index = this.searchForm.type.indexOf(key);
        if (index > -1) {
          // 如果已选中,则取消选中
          this.searchForm.type.splice(index, 1);
          // 同时取消"全部"按钮
          const allIndex = this.searchForm.type.indexOf('');
          if (allIndex > -1) {
            this.searchForm.type.splice(allIndex, 1);
          }
          
          // 如果取消后没有任何选项被选中,自动选中"全部"
          if (this.searchForm.type.length === 0) {
            this.searchForm.type = ['', ...allOtherKeys];
          }
        } else {
          // 如果未选中,则添加
          this.searchForm.type.push(key);
          // 检查是否所有非"全部"按钮都被选中
          const allSelected = allOtherKeys.every(k => this.searchForm.type.includes(k));
          if (allSelected && !this.searchForm.type.includes('')) {
            // 如果所有按钮都被选中,则自动选中"全部"
            this.searchForm.type.push('');
          }
        }
      }
      this.init()
      
      // 重新渲染图表以更新显示的线条
      // this.$nextTick(() => {
      //   this.renderChangeTrend(this.mock.changeTrend, this.searchForm.type);
      // });
    },

    // 判断筛选项是否激活
    isFilterActive(key) {
      return this.searchForm.type.includes(key);
    },

    async init() {
      this.loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)',
      });
      this.updateProductTotal();
      this.getOnSaleAnalyzeItem();
      this.getOnSaleAnalyzeStore();
      this.getOnSaleAnalyzeStoreItem();
    },

    updateProductTotal() {
      this.loadingNumber++;
      let searchForm = this.searchForm
      let data = {
        dts: searchForm.date[0],
        dte: searchForm.date[1],
        type: searchForm.type.includes('') ? [] : searchForm.type
      }
      this.$q.dataBoard.updateProductTotal({ data }).then(res => {
        if (res.code == 200) {
          this.mock.changeSummary.total = res.data.totalQty || 0;
          this.mock.changeSummary.yoy = res.data.yoy || '0%';
          
        }
      });
    },

    getOnSaleAnalyzeItem() {
      this.loadingNumber++;
      let searchForm = this.searchForm
      let data = {
        dts: searchForm.date[0],
        dte: searchForm.date[1],
        type: searchForm.type.includes('') ? [] : searchForm.type
      }
      this.$q.dataBoard.getOnSaleAnalyzeItem({ data }).then(res => {
        if (res.code == 200) {
          // 转换数据格式
          const chartData = this.transformChartData(res.data);
          this.mock.changeTrend = chartData;
          
          // 更新图表数据后重新渲染
          this.$nextTick(() => {
            this.renderChangeTrend(chartData, this.searchForm.type);
          });
        }
      });
    },

    // 转换接口数据为图表数据格式
    transformChartData(apiData) {
      if (!Array.isArray(apiData) || apiData.length === 0) {
        return {
          months: [],
          priceChange: [],
          design: [],
          delivery: [],
          salesStatus: [],
          skuPromotion: [],
          fullWidthQty: [],
          pineQty: [],
        };
      }

      return {
        months: apiData.map(item => item.month),
        priceChange: apiData.map(item => item.priceQty || 0),      // 价格相关
        design: apiData.map(item => item.designQty || 0),          // 设计图
        delivery: apiData.map(item => item.sendCycleQty || 0),     // 发货周期
        salesStatus: apiData.map(item => item.saleStatusQty || 0), // 销售状态
        skuPromotion: apiData.map(item => item.skuNameQty || 0),    // SKU推广名称
        fullWidthQty: apiData.map(item => item.fullWidthQty || 0),    // 通栏图
        pineQty: apiData.map(item => item.pineQty || 0)              // 是否松木
      };
    },
    
    getOnSaleAnalyzeStore() {
      this.loadingNumber++;
      let searchForm = this.searchForm
      let data = {
        dts: searchForm.date[0],
        dte: searchForm.date[1],
        type: searchForm.type.includes('') ? [] : searchForm.type
      }
      this.$q.dataBoard.getOnSaleAnalyzeStore({ data }).then(res => {
        if (res.code == 200) {
          this.mock.rings[0] = { ref: 'ring1', name: '已处理', value: res.data.finishedQty || 0, percent: res.data.finishedYoy || '0%' };
          this.mock.rings[1] = { ref: 'ring2', name: '未上架', value: res.data.noSaleQty || 0, percent: res.data.noSaleYoy || '0%' };
          this.mock.rings[2] = { ref: 'ring3', name: '待处理', value: res.data.waiteQty || 0, percent: res.data.waiteYoy || '0%' };
          this.mock.rings[3] = { ref: 'ring4', name: '暂缓处理', value: res.data.cannotSaleQty || 0, percent: res.data.cannotSaleYoy || '0%' };
          this.mock.meta.needMount = res.data.totalQty || 0;
          this.mock.meta.avgDays = res.data.days || 0;
          this.$nextTick(() => {
            this.renderStatusRings(this.mock.rings);
          });
        }
      });
    },

    getOnSaleAnalyzeStoreItem() {
      this.loadingNumber++;
      let searchForm = this.searchForm
      let data = {
        dts: searchForm.date[0],
        dte: searchForm.date[1],
        type: searchForm.type.includes('') ? [] : searchForm.type
      }
      this.$q.dataBoard.getOnSaleAnalyzeStoreItem({ data }).then(res => {
        if (res.code == 200) {
          this.mock.stores = res.data;
          this.$nextTick(() => {
            this.renderStoresBarLine(this.mock.stores);
          });
        }
      });
    },

    goFastProductArrivalData() {
      this.$router.push({
        path: '/newProduct/fast-product-arrival-data',
        query: {
          dts: this.searchForm.date[0],
          dte: this.searchForm.date[1],
        },
      });
    },

    handleResize() {
      // 重新渲染所有图表以适应窗口大小变化
      this.$nextTick(() => {
        // 重新渲染变更趋势图
        if (this.$refs.changeTrend) {
          const chart = this.$echarts.getInstanceByDom(this.$refs.changeTrend);
          if (chart) chart.resize();
        }
        // 重新渲染店铺柱状图
        if (this.$refs.storesBarLine) {
          const chart = this.$echarts.getInstanceByDom(this.$refs.storesBarLine);
          if (chart) chart.resize();
        }
        // 重新渲染所有状态圆环图
        this.mock.rings.forEach(item => {
          const refEl = this.$refs[item.ref];
          if (refEl) {
            const el = Array.isArray(refEl) ? refEl[0] : refEl;
            const chart = this.$echarts.getInstanceByDom(el);
            if (chart) chart.resize();
          }
        });
      });
    },
  },

  mounted() {
    // 初始化日期文本（静态页无接口也能展示区间）
    if (Array.isArray(this.searchForm.date) && this.searchForm.date.length === 2) {
      const [s, e] = this.searchForm.date;
      this.dateStartText = parseInt(String(s).slice(5, 7)) + '.' + parseInt(String(s).slice(8));
      this.dateEndText = parseInt(String(e).slice(5, 7)) + '.' + parseInt(String(e).slice(8));
    }
    this.init();

    // 监听窗口大小变化
    // window.addEventListener('resize', this.handleResize);
  },
  // beforeDestroy() {
  //   window.removeEventListener('resize', this.handleResize);
  // },
};
</script>

<style lang="stylus" scoped>
.container {
  margin: 5px;
  width: auto;
  height: calc(100vh - 76px);
  box-sizing: border-box;
  background: #0B352B;
  border-radius: 5px;
  position: relative;
  padding: 0;
  border: 0;
  z-index: 0;
  overflow-y: auto;

  &::before {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    content: '';
    background: url('../../../assets/images/newProduct_img/bg.png') no-repeat center 0px;
    background-size: cover;
    background-repeat: replace;
    z-index: -1;
  }

  /* 自定义滚动条样式 */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(5, 72, 56, 0.3);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(11, 183, 142, 0.5);
    border-radius: 4px;

    &:hover {
      background: rgba(11, 183, 142, 0.7);
    }
  }
}

// 搜索按钮样式
>>> .el-button--primary.search-btn {
  background: #0BB78E !important;
  border-color: #0BB78E !important;
  color: #fff !important;
  padding: 7px 13px

  &:hover {
    opacity: 0.9;
  }
}

>>> .el-button--info.reset-btn {
  background: rgba(5, 72, 56, 0.8) !important;
  border: 1px solid rgba(123, 255, 224, 0.5) !important;
  color: #7BFFE0 !important;

  &:hover {
    background: rgba(5, 72, 56, 1) !important;
  }
}

>>> .el-main {
  padding: 10px;
  z-index: 2;
  background: transparent;
}

>>> .el-form-item {
  margin-bottom: 0 !important;
}

>>> .el-divider {
  margin: 10px 0;
}

.list-wrapper {
  padding: 5px;
  height: calc(100% - 10px);
}

.table-wrap {
  height: 100%;
  display: block;
}

/* 筛选头部样式 */
.filter-header {
  background: rgba(5, 72, 56, 0.6);
  height: 42px;
  line-height: 42px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.filter-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-label {
  color: #fff;
  font-size: 12px;
  font-family: PingFangSC;
}

.filter-buttons {
  display: flex;
  gap: 5px;
  flex: 1;
  justify-content: center;
  margin: 0 20px;
}

.filter-btn {
  background-color: transparent !important;
  color: #7BFFE0 !important;
  border: 1px solid rgba(46, 246, 217, 0.3) !important;
  padding: 7px 13px !important;
  font-family: PingFangSC !important;
  font-size: 12px !important;
  border-radius: 2px !important;

  &:hover {
    background: rgba(11,183,142,0.5) !important;
    border-color:rgba(11,183,142,0.5) !important;
    color: #fff !important;
  }

  &.active {
    background: #0BB78E !important;
    border-color: #0BB78E !important;
    color: #fff !important;
  }
}



/* 主体网格布局 */
.main-grid {
  min-height: calc(100% - 52px);
  display: flex;
  flex-direction: column;
}

/* 顶部区域包装 */
.top-section {
  margin-bottom: 5px;
}

/* 统一的头部样式 */
.unified-header {
  background: rgba(5, 72, 56, 0.6);
  padding: 10px 12px 0 12px;
  border-radius: 4px 4px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-img {
  background: rgba(5, 72, 56, 0.6);
  padding: 8px 12px 0 12px;
}

.row {
  display: flex;
}

.col {
  flex: 1;
}

.block {
  background: rgba(5, 72, 56, 0.6);
  padding: 12px 12px 0 12px;
  border-radius: 4px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 顶部区域的 block 特殊圆角 */
.top-row .block {
  border-radius: 0 0 4px 4px;
}

.top-row .block:first-child {
  border-radius: 0 0 0 4px;
}

.top-row .block:last-child {
  border-radius: 0 0 4px 0;
}

.top-row {
  min-height: 320px;
}

.bottom-row {
  min-height: 405px;
}

.top-left {
  flex: 0.3;
}

.top-right {
  flex: 1;
}

.bottom-left {
  flex: 0.7;
  margin-right: 5px;
}

.bottom-right {
  flex: 1;
}

/* 区块头部 */
.block-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 26px;
  padding-bottom: 8px;
}

.header-left {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.bottom-box{
  margin-left: 10px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 5px;
}

.header-label {
  font-family: PingFangSC;
  color: #FFFFFF;
  font-size: 12px;
  margin-right: 5px;
}

.title {
  font-family: SourceHanSansCN;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
}

.title-sub {
  font-family: PingFangSC;
  color: #7BFFE0;
  font-size: 13px;
}

/* Tab按钮 */
.tab-btn {
  background-color: transparent !important;
  color: rgba(227, 227, 227, 0.6) !important;
  border: 1px solid rgba(46, 246, 217, 0.3) !important;
  padding: 5px 12px !important;
  font-family: PingFangSC !important;
  font-size: 12px !important;

  &:hover {
    background: #0BB78E !important;
    border-color: #0BB78E !important;
    color: #fff !important;
  }
}

/* KPI汇总区 */
.kpi-summary {
  display: flex;
  gap: 20px;
  margin-bottom: 8px;
  padding: 8px 0;
}

.kpi-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.kpi-label {
  font-family: PingFangSC;
  color: #fff;
  font-size: 13px;
}

.kpi-value {
  font-family: YinHei;
  color: #FADB65;
  font-size: 22px;
  font-weight: bold;
}

.kpi-value.highlight {
  color: #2EF9C6;
}

.trend-icon {
  width: 16px;
  height: 16px;
}

/* 图表容器 */
.chart-container {
  flex: 1;
  width: 100%;
  min-height: 200px;
}

/* 区块底部 */
.block-footer {
  margin-top: 8px;
  text-align: right;
}

.link-text {
  color: #2EF9C6;
  font-size: 12px;
  cursor: pointer;
  font-family: PingFangSC;

  &:hover {
    text-decoration: underline;
  }
}

/* KPI网格（清单数据、销售数据） */
.kpi-grid {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 10px;
}

.kpi-box {
  flex: 1;
  width: 100%;
  min-height: 0;
}

.module {
  color: rgba(255, 255, 255, 0.85);
  font-family: PingFangSC;
  background: url('../../../assets/images/newProduct_img/module.png') no-repeat center 0px;
  background-size: 100% 100%;
}

.moduleBig {
  color: rgba(255, 255, 255, 0.85);
  font-family: PingFangSC;
  background: url('../../../assets/images/newProduct_img/moduleBig.png') no-repeat center center;
  background-size: 100% 100%;
  padding: 15px;
}

.kpi-chart {
  width: 100%;
  height: 100%;
  min-height: 80px;
}

/* KPI列表样式（清单数据） */
.kpi-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 15px 0;
}

.kpi-list-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 10px;
}

.kpi-list-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  margin: 5px 0;
}

.kpi-list-label {
  flex: 1;
  font-family: PingFangSC;
  color: rgba(255, 255, 255, 0.85);
  font-size: 12px;
  text-align: left;
}

.kpi-list-value {
  font-family: YinHei;
  color: #FADB65;
  font-size: 22px;
  font-weight: bold;
  margin: 0 20px;
}
.kpi-list-right {
  flex: 0.4
  font-family: PingFangSC;
  color: rgba(255, 255, 255, 0.85);
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.kpi-list-compare {
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: PingFangSC;
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
}

  .compare-icon {
    width: 14px;
    height: 14px;
    position: relative;
    top: -1px;
  }

/* 新品销售数据样式 */
.sale-grid {
  flex: 1;
  display: flex;
  gap: 15px;
  align-items: stretch;
  padding: 10px 0;
}

.sale-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.sale-circle-wrapper {
  position: relative;
  width: 100%;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  background: rgba(2,53,44,0.5);
  border: 1px solid rgba(28,236,237,0.37);
  border-radius: 50%;
}

.sale-chart {
  width: 90%;
  height: 90%;
  position: absolute;
  top: calc(5% - 1px);
  left: calc(5% - 1px);
  border: 2px solid #44D7B6;
  border-radius: 50%;
  transform: none;
}

.sale-circle-inner {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.sale-value {
  font-family: zihun54hao-xianhei;
  font-size: 28px;
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 5px;
}

.sale-box:nth-child(1) .sale-value {
  color: #FF9800; /* 橙黄色 */
}

.sale-box:nth-child(2) .sale-value {
  color: #23BE72; /* 绿色 */
}

.sale-box:nth-child(3) .sale-value {
  color: #00D1C8; /* 青色 */
}

.sale-label {
  font-family: PingFangSC;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  white-space: nowrap;
  margin-bottom: 10px;
}

.sale-info-box {
  height: 30%;
  width: 100%;
}

.sale-info-divider{
  margin: 5px 0
  height: 0.5px;
  background-color: rgba(255,255,255,0.2);
}

.sale-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  margin-top: 10px;
}

.sale-ratio-label {
  font-family: PingFangSC;
  color: rgba(255, 255, 255, 0.85);
  font-size: 12px;
  margin-bottom: 5px;
}

.sale-compare {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC;
  color: rgba(255, 255, 255, 0.85);
  font-size: 12px;
}

.sale-date-picker {
  >>> .el-input__inner {
    height: 28px;
    line-height: 28px;
  }
}

/* 状态汇总 */
.status-summary {
  display: flex;
  gap: 15px;
  margin-bottom: 12px;
}

.status-kpi {
  flex: 1;
  padding: 20px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgba(255, 255, 255, 0.85);
  font-family: PingFangSC;
  background: url('../../../assets/images/newProduct_img/module.png') no-repeat center 0px;
  background-size: 100% 100%;
}

.status-label {
  font-family: PingFangSC;
  color: #fff;
  font-size: 14px;
  margin-bottom: 5px;
}

.status-value {
  font-family: YinHei;
  color: #FADB65;
  font-size: 20px;
  font-weight: bold;
}

/* 箭头图标样式 */
.arrow-icons {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  margin: 8px 0;
  padding-left: 0;
}

.arrow-icon {
  color: #7BFFE0;
  font-size: 12px;
  opacity: 0.8;
}

/* 变更数据样式 */
.change-summary {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 200px;
}

.change-data-box {
  width: 180px;
  height: 240px;
  color: rgba(255, 255, 255, 0.85);
  font-family: PingFangSC;
  background: url('../../../assets/images/newProduct_img/moduleBig.png') no-repeat center center;
  background-size: 100% 100%;
  padding: 15px;
}

.change-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  z-index: 2;
  text-align: center;
  flex: 1;
  padding-top: 10px;
}

.change-value {
  font-family: zihun54hao-xianhei;
  font-size: 28px;
  font-weight: bold;
  color: #FF8C00;
  line-height: 0.85;
  margin-bottom: 16px;
}

.change-label {
  font-family: PingFangSC;
  color: #fff;
  font-size: 16px;
  margin-bottom: 16px;
}

.change-yoy {
  font-family: PingFangSC;
  color: #fff;
  font-size: 14px;
  margin-bottom: 27px;
}

.change-hexagon {
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hexagon-image {
  width: 95px;
  height: 95px;
  object-fit: contain;
  filter: drop-shadow(0 0 25px rgba(0, 229, 255, 0.9)) drop-shadow(0 0 50px rgba(0, 229, 255, 0.5));
  animation: hexagonPulse 4s ease-in-out infinite;
}

@keyframes hexagonPulse {
  0%, 100% {
    filter: drop-shadow(0 0 20px rgba(0, 229, 255, 0.7)) drop-shadow(0 0 40px rgba(0, 229, 255, 0.4));
    transform: scale(1);
  }
  50% {
    filter: drop-shadow(0 0 30px rgba(0, 229, 255, 1)) drop-shadow(0 0 60px rgba(0, 229, 255, 0.6));
    transform: scale(1.03);
  }
}

/* 进度图网格 */
.rings-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  align-items: center;
  padding-top: 8px;
}

.ring-box {
  width: 100%;
  height: 100%;
  min-height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.ring-chart {
  width: 100%;
  height: 100%;
  min-height: 160px;
}

.search-btn-box {
  margin: -3px 0 0 0;
  display: flex;
  align-items: center;
  gap: 5px;
}

.buttonStyle {
  background-color: transparent;
  color: #7BFFE0;
  border: 1px solid;
  border-image: linear-gradient(270deg, rgba(11, 183, 142, 1), rgba(123, 255, 224, 1), rgba(11, 183, 142, 1)) 1 1;
  padding: 7px 13px;
}



>>> .filter-left .el-date-editor .el-range-input {
  background: transparent;
  color: #7BFFE0;
  font-size: 12px;
  font-family: PingFangSC;

  &::placeholder {
    color: rgba(123, 255, 224, 0.6);
    font-size: 12px;
  }
}


>>> .el-input__inner {
  background-color: transparent;
  border: 1px solid;
  border-image: linear-gradient(270deg, rgba(11, 183, 142, 1), rgba(123, 255, 224, 1), rgba(11, 183, 142, 1)) 1 1;
  border-radius: 2px;
  font-size: 12px;
  color: #7BFFE0;
  font-family: PingFangSC;

  &::placeholder {
    color: rgba(123, 255, 224, 0.6);
    font-size: 12px;
  }
}

>>> .el-icon-date:before {
  content: '\E78E';
  color: #7BFFE0;
}

>>> .form-date-picker .el-date-editor {
  width: 135px !important;
}

>>> .el-form--inline .el-form-item__label {
  color: #FFFFFF;
  font-family: PingFangSC;
  font-size: 12px;
}

>>> .date-picker .el-date-editor .el-range-input {
  background: transparent;
  color: #7BFFE0;
  font-size: 12px;
  font-family: PingFangSC;

  &::placeholder {
    color: rgba(123, 255, 224, 0.6);
    font-size: 12px;
  }
}

>>> .date-picker .el-range-editor.el-input__inner {
  height: 29px;
  padding: 0 10px;
  background: transparent;
  border: 1px solid;
  border-image: linear-gradient(270deg, rgba(11, 183, 142, 1), rgba(123, 255, 224, 1), rgba(11, 183, 142, 1)) 1 1;
  border-radius: 2px;
}

>>> .el-date-editor .el-range__icon {
  height: 28px;
  line-height: 28px !important;
}

>>> .el-date-editor .el-range__close-icon {
  height: 28px;
  line-height: 28px !important;
}

>>> .el-select .el-input .el-select__caret {
  height: 28px;
  line-height: 28px;
}

>>> .filter-left .el-range-editor--mini .el-range-separator {
  height: 42px;
  line-height: 42px;
  color: rgba(123, 255, 224, 0.6);
  font-size: 12px;
  font-family: PingFangSC;
}
</style>

<style scoped>
/* 响应式媒体查询 */
@media screen and (max-width: 1366px) {
  .title {
    font-size: 13px;
  }

  .title-sub {
    font-size: 11px;
  }

  .kpi-value {
    font-size: 18px;
  }

  .status-value {
    font-size: 18px;
  }

  .kpi-label,
  .status-label {
    font-size: 11px;
  }

  .tab-btn {
    padding: 4px 8px !important;
    font-size: 11px !important;
  }

  .block {
    padding: 8px;
  }

  .ring-chart {
    min-height: 140px;
  }

  .chart-container {
    min-height: 180px;
  }

  .kpi-summary {
    gap: 15px;
    padding: 5px 0;
  }

  .kpi-list-value {
    font-size: 18px;
  }

  .sale-circle-wrapper {
    height: 140px;
  }

  .sale-value {
    font-size: 22px;
  }

  .sale-label {
    font-size: 12px;
  }

  .status-summary {
    gap: 10px;
    margin-bottom: 8px;
  }

  .status-kpi {
    padding: 12px;
  }

  .top-row {
    min-height: 280px;
  }

  .bottom-row {
    min-height: 300px;
  }

  .kpi-list {
    padding: 10px 0;
  }

  .kpi-list-content {
    padding: 0 15px;
  }

  .sale-grid {
    gap: 10px;
    padding: 5px 0;
  }

  .sale-info-box {
    height: auto;
  }

  .sale-info {
    margin-top: 5px;
  }

  .top-middle {
    flex: 0.5;
  }

  .top-right {
    flex: 1.3;
  }

  .rings-grid {
    gap: 20px;
    padding: 8px 30px 0 30px;
  }

  .block-header {
    padding-bottom: 5px;
  }

  .header-label {
    font-size: 11px;
  }

  .link-text {
    font-size: 11px;
  }

  .serachBox .el-button {
    padding: 6px 10px;
  }

  ::v-deep .filter-left .el-range-editor.el-input__inner {
    height: 29px;
    padding: 0 10px;
  }
}

@media screen and (min-width: 1600px) and (max-width: 1768px) {
  .kpi-value {
    font-size: 20px;
  }

  .status-value {
    font-size: 22px;
  }

  .ring-chart {
    min-height: 150px;
  }
}
</style>
